import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";

// Auth & Core Public Pages
import Landing from "./pages/Landing";
import GoogleAuth from "./pages/GoogleAuth";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import VerifyOtp from "./pages/VerifyOtp";
import ForgotPassword from "./pages/ForgotPassword";
import VerifyResetOtp from "./pages/VerifyResetOtp";
import ResetPassword from "./pages/ResetPassword";
import ChangePassword from "./pages/ChangePassword";
import NotificationsPage from './pages/notifications/NotificationsPage';
import EditSchool from "./pages/school/EditSchool"; // adjust path to match where you saved it
// Transport Management
import PincodeRateList from "./pages/transport/PincodeRateList";
import VehicleList from "./pages/transport/VehicleList";
import StudentTransportAssignmentList from "./pages/transport/StudentTransportAssignmentList";
import AssignTransportPage from "./pages/transport/AssignTransportPage";

import OwnerWhatsAppPage from './pages/whatsapp/OwnerWhatsAppPage';
import NotificationAppsHub from './pages/notifications/NotificationAppsHub';
import PortalWhatsAppPage from './pages/whatsapp/PortalWhatsAppPage';

// School Owner Setup & Home
import SchoolHome from "./pages/SchoolHome";
import SchoolSetup from "./pages/SchoolSetup";

// Chat
import ChatPage from "./pages/chat/ChatPage";
import ChatPortalPage from "./pages/chat/ChatPortalPage";

// Role Management Pages
import RoleList from "./pages/RoleList";
import CreateRole from "./pages/CreateRole";
import RoleDetails from "./pages/RoleDetails";

// Staff Management Pages
import StaffList from "./pages/StaffList";
import AddStaff from "./pages/AddStaff";
import StaffDetail from "./pages/StaffDetail";
import AcademicYearList from './pages/academicyear/AcademicYearList';


// Student & Academic Entities Pages
import ClassList from "./pages/ClassList";
import SectionList from "./pages/SectionList";
import StudentList from "./pages/StudentList";
import AddStudent from "./pages/AddStudent";
import StudentDetail from "./pages/StudentDetail";

// Academic Calendar Pages
import AcademicCalendar from "./pages/AcademicCalendar";
import AcademicCalendarPortal from "./pages/AcademicCalendarPortal";

// Notice Board
import NoticeBoard from "./pages/NoticeBoard";

// Staff Attendance
import StaffAttendance from "./pages/StaffAttendance";
import StaffAttendancePortal from "./pages/StaffAttendancePortal";

// Staff Base Pages
import UserLogin from "./pages/UserLogin";
import StaffHome from "./pages/staffHome";
import MyProfile from "./pages/MyProfile";

// New Academic & Portal Pages
import SubjectList from "./pages/SubjectList";
import TeacherSubjectList from "./pages/TeacherSubjectList";
import TeacherSubjectPortal from "./pages/TeacherSubjectPortal";
import LeaveManagement from "./pages/LeaveManagement";
import MyLeaves from "./pages/MyLeaves";
import TimetableManager from "./pages/TimetableManager";
import MyTimetable from "./pages/MyTimetable";

// Class Teacher Portal
import MyClass from "./pages/MyClass";

// Syllabus Pages
import SyllabusTemplateList from "./pages/syllabus/SyllabusTemplateList";
import SyllabusTemplateDetail from "./pages/syllabus/SyllabusTemplateDetail";
import SyllabusProgress from "./pages/syllabus/SyllabusProgress";
import SyllabusOverview from "./pages/syllabus/SyllabusOverview";

// Student Attendance Pages
import MarkAttendance from "./pages/studentattendance/MarkAttendance";
import AbsentDashboard from "./pages/studentattendance/AbsentDashboard";
import SectionAttendance from "./pages/studentattendance/SectionAttendance";
import StudentAttendanceView from "./pages/studentattendance/StudentAttendanceView";

// Student Authentication
import { StudentAuthProvider, useStudentAuth } from "./context/StudentAuthContext";
import StudentProtectedRoute from "./components/StudentProtectedRoute";

// Student Portal Pages
import StudentLogin from "./pages/student/StudentLogin";
import StudentHome from "./pages/student/StudentHome";
import StudentProfile from "./pages/student/StudentProfile";
import StudentChangePassword from "./pages/student/StudentChangePassword";
import StudentMyLedger from "./pages/student/fees/StudentMyLedger";
import StudentMyReceipts from "./pages/student/fees/StudentMyReceipts";
import StudentPayFees from "./pages/student/fees/StudentPayFees";

// Authentication & Authorization Guards
import ProtectedRoute from "./components/ProtectedRoute";
import StaffProtectedRoute from "./components/StaffProtectedRoute";
import ModuleGuard from "./components/ModuleGuard";
import PermissionGuard from "./components/PermissionGuard";

// Context Providers
import { StaffAuthProvider, useStaffAuth } from "./context/StaffAuthContext";
import { useAuth } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import { ThemeProvider } from "./context/Themecontext";
// Examination portal (schedule only)
import ExamList from "./pages/examsschedule/ExamList";
import ExamDetail from "./pages/examsschedule/ExamDetail";
import RoomList from "./pages/examsschedule/RoomList";
import ExamSeatingPage from "./pages/examsschedule/ExamSeatingPage";
import ExamTypeList from "./pages/examsschedule/ExamTypeList";
import ScheduleList from "./pages/examsschedule/ScheduleList";

// Marks portal
import EligibleExamsPage from "./pages/markschedule/EligibleExamsPage";
import MarksAssignmentsPage from "./pages/markschedule/MarksAssignmentsPage";
import MyMarksAssignments from "./pages/markschedule/MyMarksAssignments";
import MarksEntryPage from "./pages/markschedule/MarksEntryPage";
import StandaloneSchemeList from "./pages/markschedule/StandaloneSchemeList";
import StandaloneSchemeDetail from "./pages/markschedule/StandaloneSchemeDetail";
import StandaloneMyAssignments from "./pages/markschedule/StandaloneMyAssignments";
import StandaloneMarksEntryPage from "./pages/markschedule/StandaloneMarksEntryPage";

// Report cards
import BatchList from "./pages/reportcard/BatchList";
import BatchDetail from "./pages/reportcard/BatchDetail";
import TemplateList from "./pages/reportcard/TemplateList";
import GradeSchemeList from "./pages/reportcard/GradeSchemeList";
import ReportCardView from "./pages/reportcard/ReportCardView";

// Student results — deferred module; page retained temporarily (not part of examsschedule)
import MyExamResults from "./pages/exam/MyExamResults";

import FeeHeadList from "./pages/fees/FeeHeadList";
import FeeStructurePage from "./pages/fees/FeeStructurePage";
import FeeStructureList from "./pages/fees/FeeStructureList";
import FeeBatchList from "./pages/fees/FeeBatchList";
import FeeCollectPage from "./pages/fees/FeeCollectPage";
import FeeCollectionDashboard from "./pages/fees/FeeCollectionDashboard";
import StudentFeeLedger from "./pages/fees/StudentFeeLedger";
import ReceiptsList from "./pages/fees/ReceiptList";
import FeeSettingsPage from "./pages/fees/FeeSettingsPage";
import FeeSchedulerPage from "./pages/fees/FeeSchedulerPage";
import LateFeeRulesPage from "./pages/fees/LateFeeRulesPage";
import DiscountRulesPage from "./pages/fees/DiscountRulesPage";
import PaymentModesPage from "./pages/fees/PaymentModesPage";
import BankAccountsPage from "./pages/fees/BankAccountsPage";
import TaxConfigPage from "./pages/fees/TaxConfigPage";
import NotificationTemplatesPage from "./pages/fees/NotificationTemplatesPage";
import PaymentSchedulesPage from "./pages/fees/PaymentSchedulesPage";
import FeeRefundsPage from "./pages/fees/FeeRefundsPage";
import FeeReportsPage from "./pages/fees/FeeReportsPage";
import DueFeesReport from "./pages/fees/DueFeesReport";
import StudentFeeHistory from "./pages/fees/StudentFeeHistory";

import LeaveTypeList from "./pages/payroll/LeaveTypeList";
import LeaveTypeForm from "./pages/payroll/LeaveTypeForm";
import SalaryComponentList from "./pages/payroll/SalaryComponentList";
import SalaryComponentForm from "./pages/payroll/SalaryComponentForm";
import SalaryStructureList from "./pages/payroll/SalaryStructureList";
import SalaryStructureForm from "./pages/payroll/SalaryStructureForm";
import SalaryStructureByStaff from "./pages/payroll/SalaryStructureByStaff";
import PayrollRunList from "./pages/payroll/PayrollRunList";
import PayrollRunCreate from "./pages/payroll/PayrollRunCreate";
import PayrollRunDetail from "./pages/payroll/PayrollRunDetail";
import PayslipPaymentForm from "./pages/payroll/PayslipPaymentForm";
import MyPayslips from "./pages/payroll/MyPayslips";
import MyPayslipDetail from "./pages/payroll/MyPayslipDetail";
import RoleSalaryList from "./pages/payroll/RoleSalaryList";
import RoleSalaryForm from "./pages/payroll/RoleSalaryForm";
import PayrollSettingsPage from "./pages/payroll/PayrollSettingsPage";
import PayPeriodList from "./pages/payroll/PayPeriodList";
import PayPeriodForm from "./pages/payroll/PayPeriodForm";
import ShiftRuleList from "./pages/payroll/ShiftRuleList";
import ShiftRuleForm from "./pages/payroll/ShiftRuleForm";
import OvertimeRuleList from "./pages/payroll/OvertimeRuleList";
import OvertimeRuleForm from "./pages/payroll/OvertimeRuleForm";
import StatutoryConfigPage from "./pages/payroll/StatutoryConfigPage";
import StaffBankAccountList from "./pages/payroll/StaffBankAccountList";
import StaffBankAccountForm from "./pages/payroll/StaffBankAccountForm";
import PayrollRegister from "./pages/payroll/PayrollRegister";
import BankTransferFile from "./pages/payroll/BankTransferFile";
import StatutoryReport from "./pages/payroll/StatutoryReport";
import YearEndSummary from "./pages/payroll/YearEndSummary";

// Hub Pages (grouped landing pages — one component shared by owner + staff routes)
import FeeHub from "./pages/hubs/FeeHub";
import PayrollHub from "./pages/hubs/PayrollHub";
import ExamMarksHub from "./pages/hubs/ExamMarksHub";
import StaffHub from "./pages/hubs/Staffhub";
import StudentClassesHub from "./pages/hubs/Studentclasseshub";
import AcademicsHub from "./pages/hubs/AcademicsHub";
import ReportCardHub from "./pages/hubs/ReportCardHub";

// Analytics Hub + dedicated analytics pages (one component shared by owner + staff routes)
import AnalyticsHub from "./pages/analyticshub/AnalyticsHub";
import StudentAnalyticsPage from "./pages/analyticshub/StudentAnalyticsPage";
import StaffAnalyticsPage from "./pages/analyticshub/StaffAnalyticsPage";
import FeeAnalyticsPage from "./pages/analyticshub/FeeAnalyticsPage";
import PayrollAnalyticsPage from "./pages/analyticshub/PayrollAnalyticsPage";
import ExamMarksAnalyticsPage from "./pages/analyticshub/ExamMarksAnalyticsPage";

import AppLayout from './components/header/AppLayout'; // adjust path
import { schoolNavData } from './components/header/data/schoolnavdata';
import { staffNavData } from './components/header/data/staffnavdata';
import { studentNavData } from './components/header/data/studentnavdata';
import TransportHub from "./pages/hubs/TransportHub";
// All permission keys referenced in staffNavData — used to grant a Principal
// (who bypasses individual permission checks) the full sidebar.
const ALL_STAFF_PERMISSIONS = [
  "FEE_MANAGEMENT_VIEW", "FEE_MANAGEMENT_FULL",
  "ACADEMIC_YEAR_VIEW", "EXAM_MANAGEMENT_VIEW", "TIMETABLE_VIEW",
  "ACADEMIC_CALENDAR_VIEW", "NOTICE_VIEW", "SYLLABUS_VIEW",
  "STUDENT_ATTENDANCE_VIEW", "STAFF_MANAGEMENT_VIEW", "STAFF_MANAGEMENT_FULL",
  "STAFF_ATTENDANCE_VIEW", "ROLE_MANAGEMENT_VIEW", "ROLE_MANAGEMENT_FULL",
  "CHAT_USE", "STUDENT_MANAGEMENT_VIEW", "STUDENT_MANAGEMENT_FULL",
  "SUBJECT_MANAGEMENT_VIEW", "LEAVE_MANAGEMENT_VIEW", "LEAVE_MANAGEMENT_FULL",
  "PAYROLL_MANAGEMENT_VIEW", "PAYROLL_MANAGEMENT_FULL","PAYROLL_MANAGEMENT_FULL",
  "TRANSPORT_MANAGEMENT_VIEW", "TRANSPORT_MANAGEMENT_FULL", "REPORT_CARD_FULL",
];

// Small in-tree wrapper so useStudentAuth() (which needs StudentAuthProvider
// above it) can supply the sidebar's profile/logout for student-panel routes.
function StudentAppLayoutWrapper({ children }) {
  const { student, logout } = useStudentAuth();
  return (
    <AppLayout
      navData={studentNavData}
      userPermissions={[]}
      isClassTeacher={false}
      userProfile={student}
      onLogout={logout}
    >
      {children}
    </AppLayout>
  );
}

// Wraps all owner/school-admin routes: one auth guard + one AppLayout instance,
// shared via <Outlet /> so each child route only needs to declare path + page.
function OwnerAppLayoutRoute({ user, logout }) {
  return (
    <ProtectedRoute>
      <AppLayout navData={schoolNavData} userPermissions={[]} isClassTeacher={false} userProfile={user} onLogout={logout}>
        <Outlet />
      </AppLayout>
    </ProtectedRoute>
  );
}

// Wraps all staff-portal routes the same way.
function StaffAppLayoutRoute({ staff, staffUserPermissions, isClassTeacher, staffLogout }) {
  return (
    <StaffProtectedRoute>
      <AppLayout
        navData={staffNavData}
        userPermissions={staffUserPermissions}
        isClassTeacher={isClassTeacher}
        userProfile={staff}
        onLogout={staffLogout}
        isPortal={true}
      >
        <Outlet />
      </AppLayout>
    </StaffProtectedRoute>
  );
}

function AppRoutes() {
  const { user, logout } = useAuth();
  const { staff, isClassTeacher, logout: staffLogout, isPrincipal } = useStaffAuth();
  const staffUserPermissions = isPrincipal
    ? ALL_STAFF_PERMISSIONS
    : (staff?.roleId?.permissions?.map((p) => p.key) || []);

  return (
    <Routes>

          {/* ============ PUBLIC ROUTES ============ */}
         

         
          <Route path="/" element={<Landing />} />
          <Route path="/admin-login" element={<GoogleAuth />} />

          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/verify-otp" element={<VerifyOtp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/verify-reset-otp" element={<VerifyResetOtp />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/student-login" element={<StudentLogin />} />
          <Route path="/employee-login" element={<UserLogin />} />

          {/* ============ SCHOOL OWNER / ADMIN ROUTES ============ */}
          <Route element={<OwnerAppLayoutRoute user={user} logout={logout} />}>
            <Route path="/notification-apps" element={<NotificationAppsHub />} />
            <Route path="/change-password" element={<ChangePassword />} />
          </Route>

          <Route path="/school-setup" element={<ProtectedRoute requireSchool={false}><SchoolSetup /></ProtectedRoute>} />

          {/* ============ SCHOOL OWNER / ADMIN ROUTES (continued) ============ */}
          <Route element={<OwnerAppLayoutRoute user={user} logout={logout} />}>
            <Route path="/school-home" element={<SchoolHome />} />
            <Route path="/school/edit" element={<EditSchool />} />

          {/* ============ GROUPED HUB LANDING PAGES (OWNER) ============ */}
          <Route path="/fees" element={<FeeHub isPortal={false} />} />
          <Route path="/payroll" element={<PayrollHub isPortal={false} />} />
          <Route path="/exams" element={<ExamMarksHub isPortal={false} />} />
          <Route path="/report-cards" element={<ReportCardHub isPortal={false} />} />
          <Route path="/staff-hub" element={<StaffHub isPortal={false} />} />
          <Route path="/student-classes" element={<StudentClassesHub isPortal={false} />} />

          {/* Student Attendance (owner) — mirrors /staff-panel/attendance/*
              below, same components, no guards (owner routes are ungated).
              Added so the Student & Classes hub's "Student Attendance"
              section works for owner, not just staff. */}
          <Route path="/attendance/absent-today" element={<AbsentDashboard />} />
          <Route path="/attendance/section" element={<SectionAttendance />} />
          <Route path="/attendance/student/:studentId" element={<StudentAttendanceView />} />

          <Route path="/academics" element={<AcademicsHub isPortal={false} />} />

          {/* ============ ANALYTICS HUB + PAGES (OWNER) ============ */}
          <Route path="/analytics" element={<AnalyticsHub isPortal={false} />} />
          <Route path="/analytics/students" element={<StudentAnalyticsPage isPortal={false} />} />
          <Route path="/analytics/staff" element={<StaffAnalyticsPage isPortal={false} />} />
          <Route path="/analytics/fees" element={<FeeAnalyticsPage isPortal={false} />} />
          <Route path="/analytics/payroll" element={<PayrollAnalyticsPage isPortal={false} />} />
          <Route path="/analytics/exams" element={<ExamMarksAnalyticsPage isPortal={false} />} />

          <Route path="/chat" element={<ChatPage />} />
          <Route path="/notifications" element={<NotificationsPage isPortal={false} />} />
          <Route path="/roles" element={<RoleList />} />
          <Route path="/roles/create" element={<CreateRole />} />
          <Route path="/roles/:id" element={<RoleDetails />} />
          <Route path="/staff" element={<StaffList />} />
          <Route path="/staff/create" element={<AddStaff />} />
          <Route path="/staff/:id" element={<StaffDetail />} />
          <Route path="/classes" element={<ClassList />} />
          <Route path="/sections" element={<SectionList />} />
          <Route path="/students" element={<StudentList />} />
          <Route path="/students/create" element={<AddStudent />} />
          <Route path="/students/:id" element={<StudentDetail />} />
          <Route path="/students/:id/edit" element={<AddStudent />} />
          <Route path="/academic-calendar" element={<AcademicCalendar />} />
          <Route path="/notices" element={<NoticeBoard />} />
          <Route path="/syllabus" element={<SyllabusTemplateList />} />
          <Route path="/syllabus/template/:id" element={<SyllabusTemplateDetail />} />
          <Route path="/syllabus/progress/:templateId" element={<SyllabusProgress />} />
          <Route path="/syllabus/overview/:templateId" element={<SyllabusOverview />} />
          <Route path="/academic-years" element={<AcademicYearList />} />
          <Route path="/staff-attendance" element={<StaffAttendance />} />
          <Route path="/subjects" element={<SubjectList />} />
          <Route path="/teacher-subjects" element={<TeacherSubjectList />} />
          <Route path="/leave-management" element={<LeaveManagement />} />
          <Route path="/timetable" element={<TimetableManager />} />
          <Route path="/exam/exams" element={<ExamList />} />
          <Route path="/exam/exams/:id" element={<ExamDetail />} />
          <Route path="/exam/rooms" element={<RoomList />} />
          <Route path="/exam/types" element={<ExamTypeList />} />
          <Route path="/exam/schedules" element={<ScheduleList />} />
          <Route path="/exam/seating/:scheduleId" element={<ExamSeatingPage />} />
          <Route path="/marks/eligible" element={<EligibleExamsPage />} />
          <Route path="/marks/assignments" element={<MarksAssignmentsPage />} />
          <Route path="/marks/entry/:assignmentId" element={<MarksEntryPage isPortal={false} />} />
          <Route path="/marks/standalone" element={<StandaloneSchemeList />} />
          <Route path="/marks/standalone/:id" element={<StandaloneSchemeDetail />} />
          {/* REPORT CARDS */}
          <Route path="/report-cards/batches" element={<BatchList />} />
          <Route path="/report-cards/grade-schemes" element={<GradeSchemeList />} />
          <Route path="/report-cards/templates" element={<TemplateList />} />
          <Route path="/report-cards/batches/:id" element={<BatchDetail />} />
          <Route path="/report-cards/cards/:id" element={<ReportCardView isPortal={false} />} />
          <Route path="/fees/heads" element={<FeeHeadList />} />
          <Route path="/fees/structures" element={<FeeStructurePage />} />
          <Route path="/fees/structure-list" element={<FeeStructureList />} />
          <Route path="/fees/batches" element={<FeeBatchList />} />
          <Route path="/fees/collect" element={<FeeCollectPage />} />
          <Route path="/fees/dashboard" element={<FeeCollectionDashboard />} />
          <Route path="/fees/ledger/:studentId" element={<StudentFeeLedger />} />
          <Route path="/fees/receipts" element={<ReceiptsList />} />
          <Route path="/fees/settings" element={<FeeSettingsPage />} />
          <Route path="/fees/scheduler" element={<FeeSchedulerPage />} />
          <Route path="/fees/late-fee-rules" element={<LateFeeRulesPage />} />
          <Route path="/fees/discount-rules" element={<DiscountRulesPage />} />
          <Route path="/fees/payment-modes" element={<PaymentModesPage />} />
          <Route path="/fees/bank-accounts" element={<BankAccountsPage />} />
          <Route path="/fees/tax" element={<TaxConfigPage />} />
          <Route path="/fees/notification-templates" element={<NotificationTemplatesPage />} />
          <Route path="/fees/payment-schedules" element={<PaymentSchedulesPage />} />
          <Route path="/fees/refunds" element={<FeeRefundsPage />} />
          <Route path="/fees/reports" element={<FeeReportsPage />} />
          <Route path="/fees/due-report" element={<DueFeesReport />} />
          <Route path="/fees/history/:studentId" element={<StudentFeeHistory />} />
          <Route path="/leave-types" element={<LeaveTypeList isPortal={false} />} />
          <Route path="/leave-types/create" element={<LeaveTypeForm isPortal={false} />} />
          <Route path="/leave-types/edit/:id" element={<LeaveTypeForm isPortal={false} />} />
          <Route path="/salary-components" element={<SalaryComponentList isPortal={false} />} />
          <Route path="/salary-components/create" element={<SalaryComponentForm isPortal={false} />} />
          <Route path="/salary-components/edit/:id" element={<SalaryComponentForm isPortal={false} />} />
          <Route path="/salary-structures" element={<SalaryStructureList isPortal={false} />} />
          <Route path="/salary-structures/create" element={<SalaryStructureForm isPortal={false} />} />
          <Route path="/salary-structures/staff/:staffId" element={<SalaryStructureByStaff isPortal={false} />} />
          <Route path="/payroll-runs" element={<PayrollRunList isPortal={false} />} />
          <Route path="/payroll-runs/create" element={<PayrollRunCreate isPortal={false} />} />
          <Route path="/payroll-runs/:id" element={<PayrollRunDetail isPortal={false} />} />
          <Route path="/payroll-runs/payslips/:id/payment" element={<PayslipPaymentForm isPortal={false} />} />
          <Route path="/role-salaries" element={<RoleSalaryList isPortal={false} />} />
          <Route path="/role-salaries/create" element={<RoleSalaryForm isPortal={false} />} />
          <Route path="/role-salaries/edit/:id" element={<RoleSalaryForm isPortal={false} />} />
          <Route path="/payroll-settings" element={<PayrollSettingsPage isPortal={false} />} />
          <Route path="/pay-periods" element={<PayPeriodList isPortal={false} />} />
          <Route path="/pay-periods/create" element={<PayPeriodForm isPortal={false} />} />
          <Route path="/pay-periods/edit/:id" element={<PayPeriodForm isPortal={false} />} />
          <Route path="/shift-rules" element={<ShiftRuleList isPortal={false} />} />
          <Route path="/shift-rules/create" element={<ShiftRuleForm isPortal={false} />} />
          <Route path="/shift-rules/edit/:id" element={<ShiftRuleForm isPortal={false} />} />
          <Route path="/overtime-rules" element={<OvertimeRuleList isPortal={false} />} />
          <Route path="/overtime-rules/create" element={<OvertimeRuleForm isPortal={false} />} />
          <Route path="/overtime-rules/edit/:id" element={<OvertimeRuleForm isPortal={false} />} />
          <Route path="/statutory-config" element={<StatutoryConfigPage isPortal={false} />} />
          <Route path="/bank-accounts" element={<StaffBankAccountList isPortal={false} />} />
          <Route path="/bank-accounts/create" element={<StaffBankAccountForm isPortal={false} />} />
          <Route path="/bank-accounts/edit/:id" element={<StaffBankAccountForm isPortal={false} />} />
          <Route path="/payroll-runs/:runId/register" element={<PayrollRegister isPortal={false} />} />
          <Route path="/payroll-runs/:runId/bank-transfer" element={<BankTransferFile isPortal={false} />} />
          <Route path="/payroll-runs/:runId/statutory" element={<StatutoryReport isPortal={false} />} />
          <Route path="/payroll-year-end" element={<YearEndSummary isPortal={false} />} />

          {/* ─── Transport Management – Owner ─── */}
          <Route path="/transport/pincode-rates" element={<PincodeRateList />} />
          <Route path="/transport/vehicles" element={<VehicleList />} />
          <Route path="/transport/assignments" element={<StudentTransportAssignmentList />} />
          <Route path="/transport/assign" element={<AssignTransportPage />} />
          <Route path="/transport" element={<TransportHub isPortal={false} />} />

           <Route 
                    path="/owner/whatsapp" 
                    element={<OwnerWhatsAppPage />} />
          </Route>
          {/* ============ STAFF PORTAL ROUTES ============ */}
          <Route element={<StaffAppLayoutRoute staff={staff} staffUserPermissions={staffUserPermissions} isClassTeacher={isClassTeacher} staffLogout={staffLogout} />}>
          <Route path="/staff-panel/notification-apps" element={<NotificationAppsHub isPortal={true} />} />
          <Route path="/staff-home" element={<StaffHome />} />

          {/* ============ GROUPED HUB LANDING PAGES (STAFF) ============ */}
          {/* Ungated at the route level, unlike detail pages below — each hub
              filters its own links via hasPermission() from useStaffAuth(),
              since a staff member may have access to only some links inside
              a group. See HubGrid.jsx / HubSection.jsx. */}

              
          <Route path="/staff-panel/fees" element={<FeeHub isPortal={true} />} />
          <Route path="/staff-panel/payroll" element={<PayrollHub isPortal={true} />} />
          <Route path="/staff-panel/exams" element={<ExamMarksHub isPortal={true} />} />
          <Route path="/staff-panel/report-cards" element={<ReportCardHub isPortal={true} />} />
          <Route path="/staff-panel/staff-hub" element={<StaffHub isPortal={true} />} />
          <Route path="/staff-panel/student-classes" element={<StudentClassesHub isPortal={true} />} />
          <Route path="/staff-panel/academics" element={<AcademicsHub isPortal={true} />} />

          {/* ============ ANALYTICS HUB + PAGES (STAFF) ============ */}
          {/* Hub is ungated at route level (filters its own links via hasPermission).
              Detail pages use existing module + VIEW permission keys. */}
          <Route path="/staff-panel/analytics" element={<AnalyticsHub isPortal={true} />} />
          <Route path="/staff-panel/analytics/students" element={<><ModuleGuard moduleCode="STUDENT_MANAGEMENT">
                            <PermissionGuard permissionKey="STUDENT_MANAGEMENT_VIEW">
                              <StudentAnalyticsPage isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
                           <Route path="/portal/whatsapp" element={<PortalWhatsAppPage />} />
          <Route path="/staff-panel/analytics/staff" element={<><ModuleGuard moduleCode="STAFF_MANAGEMENT">
                            <PermissionGuard permissionKey="STAFF_MANAGEMENT_VIEW">
                              <StaffAnalyticsPage isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/analytics/fees" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_VIEW">
                              <FeeAnalyticsPage isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/analytics/payroll" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT">
                            <PermissionGuard permissionKey="PAYROLL_MANAGEMENT_VIEW">
                              <PayrollAnalyticsPage isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/analytics/exams" element={<><ModuleGuard moduleCode="EXAM_MANAGEMENT">
                            <PermissionGuard permissionKey="EXAM_MANAGEMENT_VIEW">
                              <ExamMarksAnalyticsPage isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />

          <Route path="/staff-panel/chat" element={<><ModuleGuard moduleCode="CHAT">
                            <PermissionGuard permissionKey="CHAT_USE">
                              <ChatPortalPage />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/notifications" element={<NotificationsPage isPortal={true} />} />
          <Route path="/staff-panel/fees/heads" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_FULL">
                              <FeeHeadList isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/fees/structures" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_VIEW">
                              <FeeStructurePage isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/fees/structure-list" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_VIEW">
                              <FeeStructureList isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/fees/batches" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_VIEW">
                              <FeeBatchList isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/fees/collect" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_FULL">
                              <FeeCollectPage isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/fees/dashboard" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_FULL">
                              <FeeCollectionDashboard />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/fees/ledger/:studentId" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_VIEW">
                              <StudentFeeLedger isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/fees/receipts" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_VIEW">
                              <ReceiptsList isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/fees/settings" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_FULL">
                              <FeeSettingsPage isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/fees/scheduler" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_VIEW">
                              <FeeSchedulerPage isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/fees/late-fee-rules" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_FULL">
                              <LateFeeRulesPage isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/fees/discount-rules" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_FULL">
                              <DiscountRulesPage isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/fees/payment-modes" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_FULL">
                              <PaymentModesPage isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/fees/bank-accounts" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_FULL">
                              <BankAccountsPage isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/fees/tax" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_FULL">
                              <TaxConfigPage isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/fees/notification-templates" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_FULL">
                              <NotificationTemplatesPage isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/fees/payment-schedules" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_FULL">
                              <PaymentSchedulesPage isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/fees/refunds" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_FULL">
                              <FeeRefundsPage isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/fees/reports" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_VIEW">
                              <FeeReportsPage isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/fees/due-report" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_VIEW">
                              <DueFeesReport isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/fees/history/:studentId" element={<><ModuleGuard moduleCode="FEE_MANAGEMENT">
                            <PermissionGuard permissionKey="FEE_MANAGEMENT_VIEW">
                              <StudentFeeHistory isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/academic-years" element={<><ModuleGuard moduleCode="ACADEMIC_YEAR">
                            <PermissionGuard permissionKey="ACADEMIC_YEAR_VIEW">
                              <AcademicYearList isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/exam/exams" element={<><ModuleGuard moduleCode="EXAM_MANAGEMENT">
                            <PermissionGuard permissionKey="EXAM_MANAGEMENT_VIEW">
                              <ExamList isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/exam/exams/:id" element={<><ModuleGuard moduleCode="EXAM_MANAGEMENT">
                            <PermissionGuard permissionKey="EXAM_MANAGEMENT_VIEW">
                              <ExamDetail isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/exam/rooms" element={<><ModuleGuard moduleCode="EXAM_MANAGEMENT">
                            <PermissionGuard permissionKey="EXAM_MANAGEMENT_VIEW">
                              <RoomList isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/exam/types" element={<><ModuleGuard moduleCode="EXAM_MANAGEMENT">
                            <PermissionGuard permissionKey="EXAM_MANAGEMENT_VIEW">
                              <ExamTypeList isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/exam/schedules" element={<><ModuleGuard moduleCode="EXAM_MANAGEMENT">
                            <PermissionGuard permissionKey="EXAM_MANAGEMENT_VIEW">
                              <ScheduleList isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/exam/seating/:scheduleId" element={<><ModuleGuard moduleCode="EXAM_MANAGEMENT">
                            <PermissionGuard permissionKey="EXAM_MANAGEMENT_VIEW">
                              <ExamSeatingPage isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/marks/assignments" element={<><ModuleGuard moduleCode="EXAM_MANAGEMENT">
                            <PermissionGuard permissionKey="EXAM_MANAGEMENT_VIEW">
                              <MarksAssignmentsPage isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/marks/eligible" element={<><ModuleGuard moduleCode="EXAM_MANAGEMENT">
                            <PermissionGuard permissionKey="EXAM_MANAGEMENT_VIEW">
                              <EligibleExamsPage isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/marks/my-assignments" element={<MyMarksAssignments />} />
          <Route path="/staff-panel/marks/entry/:assignmentId" element={<><ModuleGuard moduleCode="EXAM_MANAGEMENT">
                            <PermissionGuard permissionKey="EXAM_MANAGEMENT_VIEW">
                              <MarksEntryPage />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/marks/standalone" element={<><ModuleGuard moduleCode="EXAM_MANAGEMENT">
                            <PermissionGuard permissionKey="EXAM_MANAGEMENT_VIEW">
                              <StandaloneSchemeList isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/marks/standalone/my-assignments" element={<StandaloneMyAssignments />} />
          <Route path="/staff-panel/marks/standalone/entry/:assignmentId" element={<><ModuleGuard moduleCode="EXAM_MANAGEMENT">
                            <PermissionGuard permissionKey="EXAM_MANAGEMENT_VIEW">
                              <StandaloneMarksEntryPage />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/marks/standalone/:id" element={<><ModuleGuard moduleCode="EXAM_MANAGEMENT">
                            <PermissionGuard permissionKey="EXAM_MANAGEMENT_VIEW">
                              <StandaloneSchemeDetail isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          {/* REPORT CARDS — staff */}
          <Route path="/staff-panel/report-cards/batches" element={<><ModuleGuard moduleCode="REPORT_CARD">
                            <PermissionGuard permissionKey="REPORT_CARD_VIEW">
                              <BatchList isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/report-cards/grade-schemes" element={<><ModuleGuard moduleCode="REPORT_CARD">
                            <PermissionGuard permissionKey="REPORT_CARD_VIEW">
                              <GradeSchemeList isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/report-cards/templates" element={<><ModuleGuard moduleCode="REPORT_CARD">
                            <PermissionGuard permissionKey="REPORT_CARD_VIEW">
                              <TemplateList isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/report-cards/batches/:id" element={<><ModuleGuard moduleCode="REPORT_CARD">
                            <PermissionGuard permissionKey="REPORT_CARD_VIEW">
                              <BatchDetail isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/report-cards/cards/:id" element={<><ModuleGuard moduleCode="REPORT_CARD">
                            <PermissionGuard permissionKey="REPORT_CARD_VIEW">
                              <ReportCardView isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/my-profile" element={<MyProfile />} />
          <Route path="/staff-panel/my-class" element={<>{isClassTeacher ? (
                            <MyClass />
                          ) : (
                            <div className="p-6 text-center text-gray-500">
                              Not authorized. This page is only available to class teachers.
                            </div>
                          )}</>} />
          <Route path="/staff-panel/syllabus" element={<><ModuleGuard moduleCode="SYLLABUS">
                            <PermissionGuard permissionKey="SYLLABUS_VIEW">
                              <SyllabusTemplateList isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/syllabus/template/:id" element={<><ModuleGuard moduleCode="SYLLABUS">
                            <PermissionGuard permissionKey="SYLLABUS_VIEW">
                              <SyllabusTemplateDetail isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/syllabus/progress/:templateId" element={<>{/* Access controlled dynamically on backend */}
                          <SyllabusProgress isPortal={true} /></>} />
          <Route path="/staff-panel/syllabus/overview/:templateId" element={<><ModuleGuard moduleCode="SYLLABUS">
                            <PermissionGuard permissionKey="SYLLABUS_VIEW">
                              <SyllabusOverview isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/my-class/attendance" element={<>{isClassTeacher ? (
                            <MarkAttendance />
                          ) : (
                            <div className="p-6 text-center text-gray-500">
                              Not authorized. This page is only available to class teachers.
                            </div>
                          )}</>} />
          <Route path="/staff-panel/attendance/absent-today" element={<><ModuleGuard moduleCode="STUDENT_ATTENDANCE">
                            <PermissionGuard permissionKey="STUDENT_ATTENDANCE_VIEW">
                              <AbsentDashboard />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/attendance/section" element={<><ModuleGuard moduleCode="STUDENT_ATTENDANCE">
                            <PermissionGuard permissionKey="STUDENT_ATTENDANCE_VIEW">
                              <SectionAttendance />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/students/:id/edit" element={<><ModuleGuard moduleCode="STUDENT_MANAGEMENT">
                            <PermissionGuard permissionKey="STUDENT_MANAGEMENT_FULL">
                              <AddStudent isPortal />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/attendance/student/:studentId" element={<><ModuleGuard moduleCode="STUDENT_ATTENDANCE">
                            <PermissionGuard permissionKey="STUDENT_ATTENDANCE_VIEW">
                              <StudentAttendanceView />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/staff" element={<><ModuleGuard moduleCode="STAFF_MANAGEMENT">
                            <PermissionGuard permissionKey="STAFF_MANAGEMENT_VIEW">
                              <StaffList isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/staff/create" element={<><ModuleGuard moduleCode="STAFF_MANAGEMENT">
                            <PermissionGuard permissionKey="STAFF_MANAGEMENT_FULL">
                              <AddStaff isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/staff/:id" element={<><ModuleGuard moduleCode="STAFF_MANAGEMENT">
                            <PermissionGuard permissionKey="STAFF_MANAGEMENT_VIEW">
                              <StaffDetail isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/students" element={<><ModuleGuard moduleCode="STUDENT_MANAGEMENT">
                            <PermissionGuard permissionKey="STUDENT_MANAGEMENT_VIEW">
                              <StudentList isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/students/create" element={<><ModuleGuard moduleCode="STUDENT_MANAGEMENT">
                            <PermissionGuard permissionKey="STUDENT_MANAGEMENT_FULL">
                              <AddStudent isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/students/:id" element={<><ModuleGuard moduleCode="STUDENT_MANAGEMENT">
                            <PermissionGuard permissionKey="STUDENT_MANAGEMENT_FULL">
                              <StudentDetail isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/academic-calendar" element={<><ModuleGuard moduleCode="ACADEMIC_CALENDAR">
                            <PermissionGuard permissionKey="ACADEMIC_CALENDAR_VIEW">
                              <AcademicCalendarPortal />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/notices" element={<><ModuleGuard moduleCode="NOTICE_BOARD">
                            <PermissionGuard permissionKey="NOTICE_VIEW">
                              <NoticeBoard isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/attendance" element={<><ModuleGuard moduleCode="STAFF_ATTENDANCE">
                            <PermissionGuard permissionKey="STAFF_ATTENDANCE_VIEW">
                              <StaffAttendancePortal />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/subjects" element={<><ModuleGuard moduleCode="SUBJECT_MANAGEMENT">
                            <PermissionGuard permissionKey="SUBJECT_MANAGEMENT_VIEW">
                              <SubjectList isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/my-subjects" element={<TeacherSubjectPortal />} />
          <Route path="/staff-panel/leaves" element={<MyLeaves />} />
          <Route path="/staff-panel/leave-management" element={<><ModuleGuard moduleCode="LEAVE_MANAGEMENT">
                            <PermissionGuard permissionKey="LEAVE_MANAGEMENT_VIEW">
                              <LeaveManagement isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/timetable" element={<><ModuleGuard moduleCode="TIMETABLE">
                            <PermissionGuard permissionKey="TIMETABLE_VIEW">
                              <TimetableManager isPortal={true} />
                            </PermissionGuard>
                          </ModuleGuard></>} />
          <Route path="/staff-panel/my-timetable" element={<MyTimetable />} />
          <Route path="/staff-panel/my-payslips" element={<MyPayslips />} />
          <Route path="/staff-panel/my-payslips/:id" element={<MyPayslipDetail />} />
          <Route path="/staff-panel/leave-types" element={<><ModuleGuard moduleCode="LEAVE_MANAGEMENT"><PermissionGuard permissionKey="LEAVE_MANAGEMENT_VIEW"><LeaveTypeList isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/leave-types/create" element={<><ModuleGuard moduleCode="LEAVE_MANAGEMENT"><PermissionGuard permissionKey="LEAVE_MANAGEMENT_FULL"><LeaveTypeForm isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/leave-types/edit/:id" element={<><ModuleGuard moduleCode="LEAVE_MANAGEMENT"><PermissionGuard permissionKey="LEAVE_MANAGEMENT_FULL"><LeaveTypeForm isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/salary-components" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_VIEW"><SalaryComponentList isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/salary-components/create" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_FULL"><SalaryComponentForm isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/salary-components/edit/:id" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_FULL"><SalaryComponentForm isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/salary-structures" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_VIEW"><SalaryStructureList isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/salary-structures/create" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_FULL"><SalaryStructureForm isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/salary-structures/staff/:staffId" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_VIEW"><SalaryStructureByStaff isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/payroll-runs" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_VIEW"><PayrollRunList isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/payroll-runs/create" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_FULL"><PayrollRunCreate isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/payroll-runs/:id" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_VIEW"><PayrollRunDetail isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/payroll-runs/payslips/:id/payment" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_FULL"><PayslipPaymentForm isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/role-salaries" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_VIEW"><RoleSalaryList isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/role-salaries/create" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_FULL"><RoleSalaryForm isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/role-salaries/edit/:id" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_FULL"><RoleSalaryForm isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/payroll-settings" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_VIEW"><PayrollSettingsPage isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/pay-periods" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_VIEW"><PayPeriodList isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/pay-periods/create" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_FULL"><PayPeriodForm isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/pay-periods/edit/:id" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_FULL"><PayPeriodForm isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/shift-rules" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_VIEW"><ShiftRuleList isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/shift-rules/create" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_FULL"><ShiftRuleForm isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/shift-rules/edit/:id" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_FULL"><ShiftRuleForm isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/overtime-rules" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_VIEW"><OvertimeRuleList isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/overtime-rules/create" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_FULL"><OvertimeRuleForm isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/overtime-rules/edit/:id" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_FULL"><OvertimeRuleForm isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/statutory-config" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_VIEW"><StatutoryConfigPage isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/bank-accounts" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_VIEW"><StaffBankAccountList isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/bank-accounts/create" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_FULL"><StaffBankAccountForm isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/bank-accounts/edit/:id" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_FULL"><StaffBankAccountForm isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/payroll-runs/:runId/register" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_VIEW"><PayrollRegister isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/payroll-runs/:runId/bank-transfer" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_FULL"><BankTransferFile isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/payroll-runs/:runId/statutory" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_VIEW"><StatutoryReport isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/payroll-year-end" element={<><ModuleGuard moduleCode="PAYROLL_MANAGEMENT"><PermissionGuard permissionKey="PAYROLL_MANAGEMENT_VIEW"><YearEndSummary isPortal={true} /></PermissionGuard></ModuleGuard></>} />

          {/* ─── Transport Management – Staff Portal ─── */}
          <Route path="/staff-panel/transport/pincode-rates" element={<><ModuleGuard moduleCode="TRANSPORT_MANAGEMENT"><PermissionGuard permissionKey="TRANSPORT_MANAGEMENT_FULL"><PincodeRateList isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/transport/vehicles" element={<><ModuleGuard moduleCode="TRANSPORT_MANAGEMENT"><PermissionGuard permissionKey="TRANSPORT_MANAGEMENT_VIEW"><VehicleList isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/transport/assignments" element={<><ModuleGuard moduleCode="TRANSPORT_MANAGEMENT"><PermissionGuard permissionKey="TRANSPORT_MANAGEMENT_FULL"><StudentTransportAssignmentList isPortal={true} /></PermissionGuard></ModuleGuard></>} />
          <Route path="/staff-panel/transport/assign" element={<><ModuleGuard moduleCode="TRANSPORT_MANAGEMENT"><PermissionGuard permissionKey="TRANSPORT_MANAGEMENT_FULL"><AssignTransportPage isPortal={true} /></PermissionGuard></ModuleGuard></>} />
         <Route path="/staff-panel/transport" element={<TransportHub isPortal={true} />} />
         
          </Route>


          {/* ============ STUDENT PORTAL ROUTES ============ */}
          <Route
                      path="/student-home"
                      element={
                        <StudentAuthProvider>
                          <StudentProtectedRoute><StudentAppLayoutWrapper>
                            <StudentHome />
                          </StudentAppLayoutWrapper></StudentProtectedRoute>
                        </StudentAuthProvider>
                      }
                    />

          <Route
                      path="/student-panel/profile"
                      element={
                        <StudentAuthProvider>
                          <StudentProtectedRoute><StudentAppLayoutWrapper>
                            <StudentProfile />
                          </StudentAppLayoutWrapper></StudentProtectedRoute>
                        </StudentAuthProvider>
                      }
                    />

          <Route
                      path="/student-panel/change-password"
                      element={
                        <StudentAuthProvider>
                          <StudentProtectedRoute><StudentAppLayoutWrapper>
                            <StudentChangePassword />
                          </StudentAppLayoutWrapper></StudentProtectedRoute>
                        </StudentAuthProvider>
                      }
                    />

          <Route
                      path="/student-panel/results"
                      element={
                        <StudentAuthProvider>
                          <StudentProtectedRoute><StudentAppLayoutWrapper>
                            <MyExamResults />
                          </StudentAppLayoutWrapper></StudentProtectedRoute>
                        </StudentAuthProvider>
                      }
                    />

          <Route
                      path="/student-panel/fees/ledger"
                      element={
                        <StudentAuthProvider>
                          <StudentProtectedRoute><StudentAppLayoutWrapper>
                            <StudentMyLedger />
                          </StudentAppLayoutWrapper></StudentProtectedRoute>
                        </StudentAuthProvider>
                      }
                    />

          <Route
                      path="/student-panel/fees/receipts"
                      element={
                        <StudentAuthProvider>
                          <StudentProtectedRoute><StudentAppLayoutWrapper>
                            <StudentMyReceipts />
                          </StudentAppLayoutWrapper></StudentProtectedRoute>
                        </StudentAuthProvider>
                      }
                    />

          <Route
                      path="/student-panel/fees/pay"
                      element={
                        <StudentAuthProvider>
                          <StudentProtectedRoute><StudentAppLayoutWrapper>
                            <StudentPayFees />
                          </StudentAppLayoutWrapper></StudentProtectedRoute>
                        </StudentAuthProvider>
                      }
                    />


    
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <ToastProvider>
          <StaffAuthProvider>
            <AppRoutes />
          </StaffAuthProvider>
        </ToastProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;